import React from 'react';
import { CommonModal, PrimaryButton } from '../../Common';
import { Grid, Typography } from '@mui/material';
import { isMobile } from '../../../utils';

const CompletionModal = ({
    open,
    onClose,
    header,
    message,
    actionButtonText,
    onAction,
    imageSrc = '/images/Asset_Create_Img.svg',
    imageAlt
}) => (
    <CommonModal
        open={open}
        close={onClose}
        header={header}
        headerTopMargin={isMobile && 8}
    >
        <Grid container>
            <Grid item xs={12} align='center'>
                <img
                    style={{ paddingTop: '1%', paddingBottom: '5%' }}
                    src={imageSrc}
                    width="300px"
                    height="300px"
                    alt={imageAlt}
                />
            </Grid>
            <Grid item xs={12} align='center'>
                <Typography
                    variant='h5'
                    sx={{
                        px: { xs: 2, md: 0 },
                        py: 2,
                        fontSize: "1.15em",
                        fontWeight: 400,
                        color: 'black'
                    }}
                >
                    {message}
                </Typography>
            </Grid>
            <Grid item xs={12} align='center' sx={{ pb: { xs: 2, md: 0 } }}>
                <PrimaryButton
                    width={70}
                    useLargeButton
                    buttonText={actionButtonText}
                    onClick={onAction}
                />
            </Grid>
        </Grid>
    </CommonModal>
);

export default CompletionModal;
